import React from "react"
import logo from "../../assets/img/logo/logo.webp"
import data from  "../../assets/data/configs/storeConfig.json"
class SpinnerComponent extends React.Component {
    render() {
        return (
            <div className="fallback-spinner d-flex align-items-center justify-content-center vh-100">
                 <div className="d-flex align-items-center justify-content-center">
                    <img src={logo} className="mr-auto ml-auto mt-2" style={{maxWidth: "200px"}} alt={data.faName}/>
                </div>
                {/*<div className="loading">*/}
                {/*    <div className="effect-1 effects"></div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default SpinnerComponent
